import { ref } from 'vue'
import type {
  IColorizedHeaderImageStore,
  IHeaderImageStore,
} from '@/store/type'

export const useImageStore = () => {
  const headerImages = ref<IHeaderImageStore[]>([])

  const getIndexForTrim = (trimName: string): number => {
    return headerImages.value.findIndex((trim: IHeaderImageStore) => {
      return trim.name === trimName
    })
  }

  const getIndexForColorizedTrim = (
    trimName: string,
    colorHex: string,
  ): number => {
    const indexFound = headerImages.value.findIndex(
      (trim: IHeaderImageStore) => {
        return trim.name === trimName
      },
    )

    if (indexFound === -1) {
      return -1
    }

    return headerImages.value[indexFound].colorizedImages.findIndex(
      (image: IColorizedHeaderImageStore) => {
        return image.colorValue === colorHex
      },
    )
  }

  const addTrim = (
    trimName: string,
    image: string = '',
    colorizedImages: IColorizedHeaderImageStore[] = [],
  ) => {
    const index = getIndexForTrim(trimName)

    if (index === -1) {
      headerImages.value.push({
        name: trimName,
        image: image,
        colorizedImages: colorizedImages,
      })
    }
  }

  const addHeaderImage = (trimName: string, image: string) => {
    const index = getIndexForTrim(trimName)
    headerImages.value[index].image = image
  }

  const getHeaderImage = (trimName: string): string => {
    const index = getIndexForTrim(trimName)
    return headerImages.value[index]?.image
  }

  const getHeaderImages = (): string[] => {
    return headerImages.value.map((trim: any) => {
      return trim
    })
  }

  const updateHeaderImage = (trimName: string, image: string) => {
    const index = getIndexForTrim(trimName)

    if (index === -1) {
      return
    }

    headerImages.value[index].image = image
  }

  const getColorizedHeaderImage = (
    trimName: string,
    colorHex: string,
  ): IColorizedHeaderImageStore | null => {
    const index = getIndexForTrim(trimName)
    return (
      headerImages.value[index]?.colorizedImages.find(
        (image: any) => image.colorValue === colorHex,
      ) ?? null
    )
  }

  const getColorizedHeaderImageUrls = (trimName: string): string[] => {
    const index = getIndexForTrim(trimName)
    return (
      headerImages.value[index]?.colorizedImages.map(
        (image: IColorizedHeaderImageStore) => image.image,
      ) || []
    )
  }

  const updateColorizedHeaderImage = (
    trimName: string,
    colorHex: string,
    colorizedImage: IColorizedHeaderImageStore,
  ) => {
    const index = getIndexForTrim(trimName)

    if (index === -1) {
      return
    }

    const colorIndex = getIndexForColorizedTrim(trimName, colorHex)

    if (colorIndex === -1) {
      headerImages.value[index].colorizedImages.push(colorizedImage)
    } else {
      headerImages.value[index].colorizedImages[colorIndex] = colorizedImage
    }
  }

  return {
    headerImages,

    addTrim,
    addHeaderImage,
    getHeaderImage,
    getHeaderImages,
    updateHeaderImage,
    getColorizedHeaderImage,
    updateColorizedHeaderImage,
    getColorizedHeaderImageUrls,
  }
}
